import { TurbidityDatum, useTurbidityData } from '@/api/historicalData';
import { turbidityIcon } from '@/assets';
import { Line } from '@/charts';
import { colorsets } from '@/charts/common';
import { SensorLineChartSection } from '@/components/spotter/historicalDataTab/SensorLineChartSection';
import { useDateRangeContext } from '@/context/DateRangeContext';
import { useSpotterContext } from '@/context/SpotterContext';

export const TURBIDITY_LINE: Line<TurbidityDatum> = {
    id: 'turbidity',
    label: 'Turbidity',
    valueKey: 'turbidity',
    unitKey: 'units',
    unitTypeKey: 'unitType',
    color: colorsets.blue, // placeholder for type; will be replaced per sensor
};

export const TurbiditySection = () => {
    const { spotterId } = useSpotterContext();
    const { dateRange } = useDateRangeContext();

    const sensorData = useTurbidityData({
        spotterId: spotterId!,
        dateRange,
    });

    return (
        <SensorLineChartSection
            chartId="turbidity"
            chartTitle="Turbidity"
            yAxisLabel="Turbidity"
            sensorType="turbidity"
            sensorData={sensorData}
            baseLine={TURBIDITY_LINE}
            sensorIcon={{
                src: turbidityIcon,
            }}
            alertLineId="smartmooring_threshold_turbidity"
        />
    );
};
